import { useEffect, useState } from 'react';
import classNames from 'classnames';
import throttle from 'lodash/throttle';
import styles from './CTABanner.module.scss';

const CTABanner = ({ children }) => {
    const [banner, setBanner] = useState(false),
        handleScroll = throttle(
            ({ target: { documentElement } }) =>
                documentElement.scrollTop > 400
                    ? setBanner(true)
                    : setBanner(false),
            100,
        );

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <section
            className={classNames(
                'banner',
                styles.banner,
                banner && styles.show,
            )}
            role="complementary"
        >
            {children}
        </section>
    );
};

export default CTABanner;
